import React from 'react'
import { useIntl } from 'react-intl'
import { useConfig } from 'msp-integrations'
import { twMerge } from 'tailwind-merge'

const CartDHLInfo = ({
  className,
  minAmountFreeShipping,
  minBoxesFreeDelivery
}: {
  className?: string
  minAmountFreeShipping?: number
  minBoxesFreeDelivery?: number
}) => {
  const { formatMessage } = useIntl()
  const {
    theme: {
      font: { regular: fontRegular }
    }
  } = useConfig()

  return (
    <div className={className}>
      <span className={twMerge(fontRegular, 'text-14 tracking-0')}>
        {formatMessage({
          id: 'msp.cart.shipment.info',
          defaultMessage: 'Shipping with DHL'
        })}
      </span>
      <div className='my-1 flex flex-col'>
        <span className={twMerge(fontRegular, 'text-12 tracking-0')}>
          {formatMessage({
            id: 'msp.cart.shipment.info.type.1',
            defaultMessage: '- Standard Delivery (3,99€)'
          })}
        </span>
        <span className={twMerge(fontRegular, 'text-12 tracking-0')}>
          {formatMessage({
            id: 'msp.cart.shipment.info.type.2',
            defaultMessage: '- Express Delivery (9,99€)'
          })}
        </span>
      </div>
      <span className={twMerge(fontRegular, 'text-14 tracking-0')}>
        {formatMessage(
          {
            id: 'msp.cart.shipment.info.2',
            defaultMessage:
              'Free packaging and shipping from {quantity} EUR or for {quantityBrews} boxes of tea.'
          },
          {
            quantity: minAmountFreeShipping,
            quantityBrews: minBoxesFreeDelivery
          }
        )}
      </span>
    </div>
  )
}

export default CartDHLInfo
